export const moduleOpenAI = {
  namespaced: true,
  state: {
    patientInfoByCall: {},
    calendarIntent: null,
    aiPanelVisible: false,
    aiPanelMinimized: false,
    aiNewPatient: false,
  },
  getters: {
    getPatientInfoByCall(state) {
      return state.patientInfoByCall;
    },
    getCalendarIntent(state) {
      return state.calendarIntent;
    },
    getAIPanelVisible(state) {
      return state.aiPanelVisible;
    },
    getAIPanelMinimized(state) {
      return state.aiPanelMinimized;
    },
    getAINewPatient(state) {
      return state.aiNewPatient;
    },
  },
  mutations: {
    upsertPatientInfo(state, info) {
      const key = info.conferenceName;
      if (!key) return;
      const existing = state.patientInfoByCall[key] || {};
      const merged = { ...existing };
      for (const k of Object.keys(info)) {
        if (k === 'conferenceName') continue;
        if (typeof info[k] === 'object' && info[k] !== null) {
          merged[k] = { ...(existing[k] || {}), ...info[k] };
        } else {
          merged[k] = info[k];
        }
      }
      state.patientInfoByCall = { ...state.patientInfoByCall, [key]: merged };
    },
    clearPatientInfo(state, conferenceName) {
      if (conferenceName) {
        const { [conferenceName]: _, ...rest } = state.patientInfoByCall;
        state.patientInfoByCall = rest;
      } else {
        state.patientInfoByCall = {};
      }
    },
    setCalendarIntent(state, intent) {
      state.calendarIntent = intent;
    },
    clearCalendarIntent(state) {
      state.calendarIntent = null;
    },
    setAIPanelVisible(state, val) {
      state.aiPanelVisible = val;
    },
    setAIPanelMinimized(state, val) {
      state.aiPanelMinimized = val;
    },
    setAINewPatient(state, val) {
      state.aiNewPatient = val;
    },
  }
};